module.exports = __webpack_public_path__ + "img/edit.4c060e3d.svg";